import { createTokenHeader } from '../utils/functions/headers';
import { TProductInfos } from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const MasterCatalogueService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['imageList'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getCatalogueProductInfo: build.query<
        TProductInfos,
        { catalogId: string; categoryCode: string }
      >({
        query: (data) => ({
          url: 'master-catalog-edit/infos',
          method: 'POST',
          data,
        }),
      }),
      uploadProductPhoto: build.mutation({
        query: ({ id, sequence, data }) => ({
          url: `catalog/photo/${id}/position/${sequence}`,
          method: 'POST',
          data,
          headers: createTokenHeader(),
        }),
        invalidatesTags: ['imageList'],
      }),
      removeProductPhoto: build.mutation({
        query: (data) => ({
          url: `catalog/photo/${data.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['imageList'],
      }),
      updateProduct: build.mutation({
        query: (data) => ({
          url: 'catalog',
          method: 'PUT',
          data,
        }),
      }),
      masterCatalogueImport: build.mutation({
        query: (data) => ({
          url: 'master/catalog/import',
          method: 'POST',
          data,
          headers: createTokenHeader(),
        }),
      }),
      masterCatalogueExport: build.mutation({
        query: (data) => ({
          url: 'master/catalog/export/v2',
          method: 'POST',
          data,
        }),
      }),
    }),
  });

export const {
  useGetCatalogueProductInfoQuery,
  useUploadProductPhotoMutation,
  useRemoveProductPhotoMutation,
  useMasterCatalogueExportMutation,
  useMasterCatalogueImportMutation,
} = MasterCatalogueService;
